import config from '../../config';
import React, { Component } from 'react';
import Edito from '../Edito/Edito';
import Element from '../Element/Element';
import StaticElement from '../StaticElement/StaticElement';
import Skew from '../Skew/Skew';
import Video from '../Video/Video';
import Masthead from '../Masthead/Masthead';
import './Board.css';


function getSizes() {
    var width = Math.min(document.documentElement.clientWidth, config.ratio.width),
		height = Math.min(document.documentElement.clientHeight, config.ratio.height),
		mobile = false,
        slideWidth = width,
        boardHeight = height,
        boardTop = 0;

	if (width < config.ratio.width) {
		mobile = true;
	}
    if (width / height < config.ratio.width / config.ratio.height) {
        boardHeight = config.ratio.height * width / config.ratio.width;
        boardTop = (document.documentElement.clientHeight - boardHeight) / 2;
	}

    return {
        slideWidth: slideWidth,
        boardHeight: boardHeight,
		boardTop: boardTop,
		mobile : mobile
    }
}

export default class Board extends Component {

    constructor(props) {
        super(props);

        this.state = {
            slideWidth:getSizes().slideWidth,
            boardHeight:getSizes().boardHeight,
			boardTop:getSizes().boardTop,
			mobile:getSizes().mobile
        };
    }

    componentDidMount() {
        var _this = this;
        window.addEventListener('resize', function () {
            _this.setState({
                slideWidth:getSizes().slideWidth,
                boardHeight:getSizes().boardHeight,
				boardTop:getSizes().boardTop,
				mobile:getSizes().mobile
            });
        });
    }

    render() {
		var mobile = this.state.mobile;
        return (
            <div id="board" className="Board" style={{marginTop:this.state.boardTop, left:0,  minWidth:this.state.slideWidth, height: this.state.boardHeight}}>


                {/* CHAP 0 - Introduction */}
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                    <Skew position="left" name="" bg="CHAP00-OUVERTURE.png"></Skew>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[0].zone_1} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[0].zone_2} positionTop="35%"></Edito>
                    <Element name="CHAP00-CLAVIER.png" index="m1" positionLeft="5%"></Element>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                    <StaticElement bg="CHAP00-ENCADRE-FORTNITE.png" size="double"></StaticElement>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[0].zone_3} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide Board__slide--bottom board-small-slide" style={!mobile ? {minWidth: '56vh'} : {}}>
                     <StaticElement bg="CHAP00-PHOTO-ARTHUR.png" size="simple"></StaticElement>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[0].zone_4} positionTop="35%"></Edito>
                </div>
                <div className="Board__slide Board__slide--middle board-small-slide" style={!mobile ? {minWidth: '65vh'} : {}}>
                    <Element name="CHAP00-INFOG-SAM.png" index="p1" positionLeft="-2%"></Element>
                </div>
                <div className="Board__slide Board__slide--middle board-small-slide" style={!mobile ? {minWidth: '65vh'} : {}}>
                    <Element name="CHAP00-INFOG-SAM-JOUEURS.png" index="p1" positionLeft="-2%"></Element>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[0].zone_5} positionTop="35%"></Edito>
                    <Element name="CHAP00-ECRAN.png" index="m1" positionLeft="5%" positionTop="5%"></Element>
                </div>

                {/* CHAP 1 */}
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                    <Skew position="left" name="CHAP01-TITRE.png" bg="CHAP01-OUVERTURE.png"></Skew>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                </div>
                <div className="Board__slide Board__slide--top" >
                    <Edito content={this.props.datas.text[1].zone_1} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide  Board__slide--top" >
                    <Edito content={this.props.datas.text[1].zone_2}  positionTop="35%"></Edito>
                </div>
                <div className="Board__slide Board__slide--bottom board-small-slide" style={!mobile ? {minWidth: '56vh'} : {}}>
                     <StaticElement bg="CHAP01-CASQUE-BLANC.png" size="simple"></StaticElement>
                </div>
                <div className="Board__slide  Board__slide--top" >
                    <Edito content={this.props.datas.text[1].zone_3}  positionTop="15%"></Edito>
                    <Element name="CHAP01-NUITBLANCHE-LOGO.png" index="m1"></Element>
                </div>
                <div className="Board__slide Board__slide--middle board-small-slide" style={!mobile ? {minWidth: '65vh'} : {}}>
                    <Element name="CHAP01-EXERGUE-SAMCHAKA.png" index="p1" positionLeft="-2%"></Element>
                </div>
                <div className="Board__slide Board__slide--middle">
                    <Edito content={this.props.datas.text[1].zone_4} positionTop="15%"></Edito>
                    <Element name="CHAP01-GROSBILL-LOGO.png" index="m1"></Element>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                    <StaticElement bg="CHAP01-ENCADRE-RODIER.png" size="double"></StaticElement>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[1].zone_5} positionTop="35%"></Edito>
                    <Element name="CHAP01-ARTIC-LOGO.png" index="m1"></Element>
                </div>
                <div className="Board__slide"> 
                    <Element name="CHAP1-DOUBLE-PHOTO.png" index="p1"></Element>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[1].zone_6} positionTop="15%"></Edito>
                    <Element name="CHAP01-MACROMANIACS-LOGO.png" index="m1"></Element>
                </div>
                <div className="Board__slide Board__slide--middle board-small-slide" style={!mobile ? {minWidth: '65vh'} : {}}>
                    <Element name="CHAP01-EXERGUE-TURKINATOR.png" index="p1" positionLeft="-2%"></Element>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[1].zone_7} positionTop="35%"></Edito>
                    <Element name="CHAP01-BURSASPOR-LOGO.png" index="m1"></Element>
                </div>
                <div className="Board__slide">
                    <Video id="x76xctp" maxHeight="300" ratio="1.778"></Video>
                    <Element name="CHAP01-TITRE-VIDEO.png" index="p1"></Element>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[1].zone_8} positionTop="35%"></Edito>
                    <Element name="CHAP01-SOLARY-LOGO.png" index="m1"></Element>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Element name="CHAP01-MUR-CITATIONS.png" index="p1" ></Element>
                </div>
                <div className="Board__slide Board__slide--top">
                </div>
                 <div className="Board__slide Board__slide--top">
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[1].zone_9}  positionTop="15%"></Edito>
                </div>

                {/* CHAP 2 */}

                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                    <Skew position="left" name="CHAP02-TITRE.png" bg="CHAP02-OUVERTURE.png"></Skew>
                </div>
                <div className="Board__slide Board__slide--middle board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[2].zone_1} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                    <StaticElement bg="CHAP02-ENCADRE-SOLARY.png" size="simple"></StaticElement>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[2].zone_2} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                    <StaticElement bg="CHAP02-PHOTO-AMAURY-VEDIS.png" name="CHAP02-PHOTO-AMAURY-VEDIS-LEGENDE.png" size="double"></StaticElement>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[2].zone_3} positionTop="35%"></Edito>
                    <Element name="CHAP02-SOURIS.png" index="m1"></Element>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[2].zone_4} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                    <StaticElement bg="CHAP02-PHOTO-SKIRMISH.png" name="CHAP02-PHOTO-SKIRMISH-LEGENDE.png" size="double"></StaticElement>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[2].zone_5}  positionTop="35%"></Edito>
                </div>
                <div className="Board__slide Board__slide--middle board-small-slide" style={!mobile ? {minWidth: '65vh'} : {}}>
                    <Element name="CHAP02-EXERGUE-TRAYTON.png" index="p1" positionLeft="-2%"></Element>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[2].zone_6} positionTop="15%"></Edito>
                 </div>
                 <div className="Board__slide">
                    <Video id="x76xjvh" maxHeight="300" ratio="1.778"></Video>
                    <Element name="CHAP02-TITRE-VIDEO.png" index="p1"></Element>
                 </div>
                 <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[2].zone_7} positionTop="15%"></Edito>
                 </div>

                {/* CHAP 3 - Conclusion */}

                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                    <Skew position="left" name="CHAP03-TITRE.png" bg="CHAP03-OUVERTURE.png"></Skew>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}></div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[3].zone_1} positionTop="35%"></Edito>
                    <Element name="CHAP03-CHAISE.png" index="m1" positionLeft="65%"></Element>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[3].zone_2} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide">
                    <Video id="x76xhab" maxHeight="300" ratio="1.778"></Video>
                    <Element name="CHAP03-TITRE-VIDEO.png" index="p1"></Element>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[3].zone_3} positionTop="25%"></Edito>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                <StaticElement bg="CHAP03-PHOTO-IEM.png" name="CHAP03-PHOTO-IEM-LEGENDE.png" size="double"></StaticElement>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[3].zone_4} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide Board__slide--bottom board-small-slide" style={!mobile ? {minWidth: '56vh'} : {}}>
                     <StaticElement bg="CHAP03-ENCADRE-COUPE-DU-MONDE.png" size="simple"></StaticElement>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[3].zone_5} positionTop="35%"></Edito>
                </div>
                 <div className="Board__slide Board__slide--middle board-small-slide" style={!mobile ? {minWidth: '65vh'} : {}}>
                    <Element name="CHAP03-EXERGUE-BESOMBES.png" index="p1" positionLeft="-2%"></Element>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[3].zone_6} positionTop="25%"></Edito>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[3].zone_7} positionTop="35%"></Edito>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                    <StaticElement bg="CHAP03-ENCADRE-DERKAZ.png" size="double"></StaticElement>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[3].zone_8} positionTop="35%"></Edito>
                </div>
                <div className="Board__slide"> 
                    <Element name="CHAP03-CLASSEMENT-WORLD-CUP.png" index="p1"></Element>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                <StaticElement bg="CHAP03-PHOTO-SAM-JOUEURS.png" name="CHAP03-PHOTO-SAM-JOUEURS-LEGENDE.png" size="double"></StaticElement>
                </div>
                <div className="Board__slide board-small-slide" style={!mobile ? {minWidth: '55vh'} : {}}>
                </div>
                <div className="Board__slide Board__slide--top">
                    <Edito content={this.props.datas.text[3].zone_9} positionTop="15%"></Edito>
                </div>
                <div className="Board__slide">
                    <Skew position="left" bg="OURS.png" ></Skew>
                </div>
                <div className="Board__slide">
                    <Masthead />
                </div>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/components/Board/Board.js